import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { ProvenSystem } from "@/components/ProvenSystem";
import { Services } from "@/components/Services";
import { AreasServed } from "@/components/AreasServed";
import { AgentBio } from "@/components/AgentBio";
import { Testimonials } from "@/components/Testimonials";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <div className="bg-white">
      <Header />
      <main>
        <Hero />
        <ProvenSystem />
        <Services />
        <AreasServed />
        <AgentBio />
        <Testimonials />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
